<template>
	<c-dialog ref="dialog" title="入库单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.order_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.order_code}}</label>
				<c-state dict="stockinClassifyName" tag :value="detailData.order_classify"></c-state>
				<c-state dict="approveStateDic" tag :value="detailData.approve_state"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="入库单二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="入库仓库">
						{{detailData.warehouse_name}} [{{detailData.warehouse_code}}]
					</c-detail-item>
					<c-detail-item label="入库数量">
						{{detailData.storage_count}}
					</c-detail-item>
					<c-detail-item label="入库时间">
						{{detailData.storage_date}}
					</c-detail-item>
					<c-detail-item label="客户">
						{{detailData.customer_name}}
					</c-detail-item>
					<c-detail-item label="供应商">
						{{detailData.supplier_name}}
					</c-detail-item>
					<c-detail-item label="备注">
						{{detailData.remark}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item label="审批人">
						{{detailData.approve_user_realname}}
					</c-detail-item>
					<c-detail-item label="审批时间">
						{{detailData.approve_date}}
					</c-detail-item>
					<c-detail-item v-if="detailData.ref_id" label="关联单据">
						<order-link :type="detailData.ref_type" :id="detailData.ref_id" :code="detailData.ref_code"></order-link>
					</c-detail-item>
					<c-detail-item label="库存批次" v-if="systemConfig.batch_stock == 1">
						{{detailData.batch_code}}
					</c-detail-item>
					<c-detail-item label="批次库位" v-if="systemConfig.batch_stock == 1">
						{{detailData.batch_remark}}
					</c-detail-item>
					<custom-detail work-type="20" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="产品明细" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="productTable" view-id="20019" height="grow" paging readonly>
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'stockinDetail',
		computed: {
			// 获取dictName选项数据
			...mapState(['systemConfig']),
		},
		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/stockin/order/overview',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.productTable.init();
						this.$refs.productTable.$refs.list.setData(data.productList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>